import { orderTermIsNet60 } from "../../utils/orderTermIsNet60";
import { orderTermIsPaymentOnShipment } from "../../utils/orderTermIsPaymentOnShipment";
import { orderWasAlreadyCharged } from "../../utils/orderWasAlreadyCharged";
export var RefundsIA = function RefundsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return REFUNDS(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getDescription(context, strictLocalize);
    }
  };
};
var getDescription = function getDescription(context, strictLocalize) {
  var withSharedParagraphs = function withSharedParagraphs(intro) {
    return [intro(strictLocalize), PLEASE_NOTE(strictLocalize), FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize)];
  };
  var brandOrder = context.brandOrder;
  if (!brandOrder) {
    return withSharedParagraphs(REFUNDS_EXPLANATION);
  }
  if (orderTermIsNet60(brandOrder) && !orderWasAlreadyCharged(brandOrder)) {
    return withSharedParagraphs(WE_WILL_NOT_CHARGE_YOU);
  }
  if (orderTermIsPaymentOnShipment(brandOrder)) {
    return withSharedParagraphs(YOU_WILL_GET_A_REFUND);
  }
  return withSharedParagraphs(REFUNDS_EXPLANATION);
};
var REFUNDS = function REFUNDS(strictLocalize) {
  return strictLocalize({
    id: "j0Zb++",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe terugbetalingen werken"
    }]
  });
};
var WE_WILL_NOT_CHARGE_YOU = function WE_WILL_NOT_CHARGE_YOU(strictLocalize) {
  return strictLocalize({
    id: "nlChIa",
    defaultMessage: [{
      "type": 0,
      "value": "Aangezien je voor je bestelling gebruik hebt gemaakt van je 60 dagen netto betalingstermijnen en de factuur nog niet is betaald, brengen we geen kosten in rekening voor de artikelen die je retourneert."
    }]
  });
};
var FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER = function FREE_RETURNS_ELIGIBLE_FOR_FIRST_BRAND_ORDER(strictLocalize) {
  return strictLocalize({
    id: "8EzeWX",
    defaultMessage: [{
      "type": 0,
      "value": "Alleen je eerste bestelling bij een merk komt in aanmerking voor gratis retourneren. Verzendkosten voor retourzendingen worden gedekt door Faire, maar de oorspronkelijke verzendkosten en invoerheffingen worden niet terugbetaald. Als een factuur is betaald met een Faire-tegoed en een betaalkaart, wordt het tegoed eerst teruggestort. Als het Faire Direct-tegoed aanvankelijk is gebruikt om een bestelling te betalen die geretourneerd is, wordt het tegoed niet automatisch teruggestort op je Faire-account."
    }]
  });
};
var YOU_WILL_GET_A_REFUND = function YOU_WILL_GET_A_REFUND(strictLocalize) {
  return strictLocalize({
    id: "HOxj0J",
    defaultMessage: [{
      "type": 0,
      "value": "Aangezien de bestelling is geplaatst met betaling bij verzending, worden de kosten van de artikelen die je retourneert rechtstreeks teruggestort op je oorspronkelijke betaalmethode op het moment dat de retourzending door de vervoerder wordt gescand. Het kan vijf tot tien werkdagen duren voordat de terugbetaling op je betaalmethode zichtbaar is."
    }]
  });
};
var REFUNDS_EXPLANATION = function REFUNDS_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "DB4OtG",
    defaultMessage: [{
      "type": 0,
      "value": "Als je voor de bestelling gebruik hebt gemaakt van je betalingstermijn van netto 60 dagen en de factuur nog niet is betaald, brengen we geen kosten in rekening voor de artikelen die je retourneert. Als de je voor de bestelling hebt betaald op het moment van verzending, worden de kosten van artikelen die je retourneert rechtstreeks teruggestort op je oorspronkelijke betaalmethode op het moment dat de retourzending door de vervoerder wordt gescand. Het kan vijf tot tien werkdagen duren voordat de terugbetaling op je betaalmethode zichtbaar is."
    }]
  });
};
var PLEASE_NOTE = function PLEASE_NOTE(strictLocalize) {
  return strictLocalize({
    id: "Vr8ECj",
    defaultMessage: [{
      "type": 0,
      "value": "Let op:"
    }]
  });
};